import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getPersonProfile = () => {
  return http.get(
    `${getBaseUrl()}/person_profile`
  );
};

export const getPersonsNameAndFamily = () => {
  return http.get(
    `${getBaseUrl()}/persons_name_and_family`
  );
};

export const getPersonsNameAndFamilyReferral = () => {
  return http.get(
    `${getBaseUrl()}/persons_name_and_family_referral`
  );
};

export const getPersonsNameAndFamilyByRole = data => {
  return http.get(
    `${getBaseUrl()}/persons_name_and_family/${data}`
  );
};

export const getPersonsPhone = () => {
  return http.get(
    `${getBaseUrl()}/persons_phone`
  );
};

export const getPersonsPhoneByRole = data => {
  return http.get(
    `${getBaseUrl()}/persons_phone/${data}`
  );
};

export const getPersonsNationalCode = () => {
  return http.get(
    `${getBaseUrl()}/persons_national_code`
  );
};

export const getPersonsNationalCodeByRole = data => {
  return http.get(
    `${getBaseUrl()}/persons_national_code/${data}`
  );
};

export const updatePersonProfile = data => {

  return http.put(
    `${getBaseUrl()}/person_profile`,
    data
  );
};

export const updateProfilePhoto = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/profile_photo`,
    data
  );
};
